"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apply = void 0;
const random_seed_1 = __importDefault(require("random-seed"));
// credit: https://stackoverflow.com/a/15710692
const hashCode = (s) => s.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
}, 0);
function apply(configurations, forService, forUser, forClient) {
    if (!configurations)
        return configurations;
    let configs = new Map(configurations);
    configs.forEach((value, key) => {
        var _a, _b, _c, _d;
        // Coin flip enabled based on ratio
        if (forClient && value.ratio) {
            const random = new random_seed_1.default(hashCode('extra peri sauce for the seed goes here <3' + forClient));
            value.enabled = random.random() <= value.ratio;
        }
        // UserID overrides
        if (forUser) {
            if (((_a = value.disabledForUser) === null || _a === void 0 ? void 0 : _a.indexOf(forUser)) !== -1) {
                // override disable if disabledForUser
                value.enabled = false;
            }
            else if (((_b = value.enabledForUser) === null || _b === void 0 ? void 0 : _b.indexOf(forUser)) !== -1) {
                // override enable if enabledForUser
                value.enabled = true;
            }
        }
        // Service overrides
        if (forService) {
            if (((_c = value.disabledFor) === null || _c === void 0 ? void 0 : _c.indexOf(forService)) !== -1) {
                // override disable if disabledFor
                value.enabled = false;
            }
            else if (((_d = value.enabledFor) === null || _d === void 0 ? void 0 : _d.indexOf(forService)) !== -1) {
                // override enable if enabledFor
                value.enabled = true;
            }
        }
        configs.set(key, value);
    });
    return configs;
}
exports.apply = apply;
//# sourceMappingURL=sorter.js.map